import React from 'react';

/**
 * Znak the.rENT jako SVG w treści strony (U.30). Geometria 1:1 z `public/logo.svg`
 * (ramka 112×112 z obrysem 5, dwa nawiasy o grubości 6), ale bez tła i na `currentColor`:
 * plik ma wpisany granat #1c2544, który na ciemnym motywie znika. Zgodności geometrii z plikiem
 * pilnuje `components/__tests__/brandMark.test.js`.
 *
 * Prawy nawias jest w pliku szary (#585f70). Tu oddaje to krycie obrysu: 0,73 to krycie, przy
 * którym granat #1c2544 na tle logo (#f5f6f8) daje tę szarość.
 *
 * Rozmiar nadaje miejsce użycia przez CSS (`className`); bez niego znak ma wysokość litery.
 */
export default function BrandMark(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 111 111"
      width="1em"
      height="1em"
      role="img"
      aria-label="the.rENT"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <rect x="2.5" y="2.5" width="106" height="106" rx="9.5" strokeWidth="5" />
      <path d="M53 28 H33 V83 H53" strokeWidth="6" />
      <path d="M58 28 H78 V83 H58" strokeWidth="6" strokeOpacity="0.73" />
    </svg>
  );
}
